/* Copyright 2019 Google LLC All Rights Reserved.

  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.
  ==============================================================================*/

export const TSNE_MAMMOTH_PERPLEXITIES = [
  5,
  15,
  30,
  50,
  100,
  200,
  500,
  1000,
  2000
];

export const N_BITS_HYPERPARAMETERS = 8;
export const N_BITS_TOY_COMPARISON = 8;
export const N_BITS_MAMMOTH = 10;
